import React, { useState, useEffect } from 'react';
import { t } from '../i18n';
import { useParams, useNavigate } from 'react-router-dom';

const BACKEND = '/api';

const CATEGORY_ICONS = {
  food: 'F', retail: 'S', services: 'C', health: 'H',
  tech: 'T', education: 'E', travel: 'V', other: 'B'
};

export default function MerchantPage() {
  const { slug } = useParams();
  const navigate = useNavigate();
  const [merchant, setMerchant] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [review, setReview] = useState({ rating: 5, comment: '' });
  const [reviewMsg, setReviewMsg] = useState('');
  const [payMode, setPayMode] = useState(false);
  const [payAmount, setPayAmount] = useState(1);
  const [payStatus, setPayStatus] = useState('');
  const [transactions, setTransactions] = useState([]);
  const [showTx, setShowTx] = useState(false);
  const piUser = JSON.parse(localStorage.getItem('xpert_user') || '{}');
  const [userAvatar, setUserAvatar] = useState(localStorage.getItem('xpert_avatar') || null);

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (token && piUser.username) {
      fetch(BACKEND.replace('/api', '') + '/api/profile/' + piUser.username + '/')
        .then(r => r.json())
        .then(d => { if (d.avatar) setUserAvatar(d.avatar); })
        .catch(() => {});
    }
  }, [piUser.username]);
  const [verifStatus, setVerifStatus] = useState(null);
  const [editMode, setEditMode] = useState(false);
  const [editForm, setEditForm] = useState({});
  const [editMsg, setEditMsg] = useState('');
  const [emailCode, setEmailCode] = useState('');
  const [waCode, setWaCode] = useState('');
  const [waLink, setWaLink] = useState('');
  const [verifMsg, setVerifMsg] = useState('');
  const currentUser = piUser;

  useEffect(() => {
    fetchMerchant();
    fetchVerifStatus();
    if (window.Pi) {
      try {
        window.Pi.authenticate(['username', 'payments'], async function(payment) {
          const txid = payment.transaction ? payment.transaction.txid : null;
          if (!txid) return;
          try {
            await fetch(BACKEND + '/merchants/payment/approve/', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ paymentId: payment.identifier })
            });
            await fetch(BACKEND + '/merchants/payment/complete/', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ paymentId: payment.identifier, txid: txid, amount: payment.amount })
            });
          } catch(e) {}
        }).then(auth => {
          localStorage.setItem('xpert_user', JSON.stringify(auth.user));
        }).catch(e => {});
      } catch(e) {}
    }
  }, [slug]);

  const fetchMerchant = async () => {
    try {
      const r = await fetch(BACKEND + '/merchants/' + slug + '/');
      const d = await r.json();
      if (d.error) setError(d.error);
      else setMerchant(d);
    } catch(e) { setError(t('mp_load_fail')); }
    setLoading(false);
  };

  const fetchVerifStatus = async () => {
    const token = localStorage.getItem('token');
    if (!token) return;
    try {
      const r = await fetch(BACKEND + '/merchants/verify/status/', {
        headers: { 'Authorization': 'Token ' + token }
      });
      const d = await r.json();
      setVerifStatus(d);
    } catch(e) {}
  };

  const fetchTransactions = async () => {
    try {
      const r = await fetch(BACKEND + '/merchants/transactions/' + merchant.id + '/');
      const d = await r.json();
      setTransactions(d.transactions || []);
    } catch(e) {}
  };

  const payWithPi = async () => {
    if (!window.Pi) { setPayStatus('Please open in Pi Browser'); return; }
    setPayStatus('Starting payment...');
    try {
      await window.Pi.createPayment({
        amount: payAmount,
        memo: 'Payment to ' + merchant.business_name,
        metadata: { merchantId: merchant.id, type: 'merchant_payment' }
      }, {
        onReadyForServerApproval: async function(pid) {
          setPayStatus('Approving...');
          try {
            await fetch(BACKEND + '/merchants/payment/approve/', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ paymentId: pid, merchantId: merchant.id, amount: payAmount, buyer_username: piUser.username || '' })
            });
          } catch(e) {}
        },
        onReadyForServerCompletion: async function(pid, txid) {
          try {
            await fetch(BACKEND + '/merchants/payment/complete/', {
              method: 'POST', headers: {'Content-Type': 'application/json'},
              body: JSON.stringify({ paymentId: pid, txid: txid, merchantId: merchant.id, amount: payAmount, buyer_username: piUser.username || '' })
            });
          } catch(e) {}
          setPayStatus('Payment Successful! ' + payAmount + ' Pi sent');
          setPayMode(false);
          fetchMerchant();
    fetchVerifStatus();
        },
        onCancel: function() { setPayStatus('Payment cancelled'); },
        onError: function(e) { setPayStatus('Error: ' + e.message); }
      });
    } catch(e) { setPayStatus('Error: ' + e.message); }
  };

  const submitReview = async () => {
    const token = localStorage.getItem('token');
    if (!token) { setReviewMsg('Please login first'); return; }
    try {
      const r = await fetch(BACKEND + '/merchants/review/' + merchant.id + '/', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': 'Token ' + token },
        body: JSON.stringify(review)
      });
      const d = await r.json();
      if (d.success) { setReviewMsg('Review submitted!'); fetchMerchant(); }
      else setReviewMsg('Error: ' + (d.error || 'Unknown'));
    } catch(e) { setReviewMsg('Error'); }
  };

  if (loading) return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ color: '#0F6E56', fontSize: 24 }}>{t('mp_loading')}</div>
    </div>
  );

  if (error || !merchant) return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <div style={{ fontSize: 48 }}>B</div>
      <p style={{ color: '#ef4444', fontSize: 18 }}>{error || 'Merchant not found'}</p>
    </div>
  );

  const planColor = merchant.plan === 'unlimited' ? '#3b82f6' : merchant.plan === 'pro' ? '#3b82f6' : merchant.plan === 'starter' ? '#22c55e' : '#0891b2';
  const planLabel = merchant.plan === 'unlimited' ? 'Unlimited' : merchant.plan === 'pro' ? 'Pro' : merchant.plan === 'starter' ? 'Starter' : 'Basic';

  return (
    <div style={{ minHeight: '100vh', background: '#0a0e1a', color: '#fff', fontFamily: 'Arial, sans-serif' }}>

      {/* Top Bar */}
      <div style={{ padding: '12px 20px', background: '#1a1a2e', borderBottom: '1px solid #2a2a4a', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <button onClick={() => navigate('/directory')} style={{ background: 'none', border: 'none', color: '#0F6E56', cursor: 'pointer', fontSize: 14 }}>{t('mp_back_dir')}</button>
        {piUser.username && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
            <div style={{ width: 38, height: 38, borderRadius: '50%', overflow: 'hidden', border: '2px solid #0F6E56', flexShrink: 0 }}>
              {userAvatar ? (
                <img src={userAvatar} alt={piUser.username} style={{ width: '100%', height: '100%', objectFit: 'cover' }} />
              ) : (
                <div style={{ width: '100%', height: '100%', background: '#0F6E56', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#000', fontWeight: 'bold', fontSize: 18 }}>
                  {piUser.username ? piUser.username.charAt(0).toUpperCase() : 'U'}
                </div>
              )}
            </div>
            <div>
              <div style={{ color: '#fff', fontSize: 13, fontWeight: 'bold' }}>@{piUser.username}</div>

              
            </div>
          </div>
        )}
      </div>

      {/* Hero */}
      <div style={{ background: 'linear-gradient(135deg, #1a1a2e 0%, #16213e 100%)', padding: '30px 20px', borderBottom: '1px solid #2a2a4a', textAlign: 'center' }}>
        <div style={{ marginBottom: 16, position: 'relative', display: 'inline-block' }}>
          {merchant.logo ? (
            <img src={merchant.logo} alt={merchant.business_name}
              style={{ width: 100, height: 100, borderRadius: '50%', objectFit: 'cover', border: '3px solid #0F6E56' }} />
          ) : (
            <div style={{ width: 100, height: 100, borderRadius: '50%', background: '#0d1b2a', border: '3px solid #0F6E56', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 40, color: '#0F6E56', fontWeight: 'bold' }}>
              {merchant.business_name.charAt(0).toUpperCase()}
            </div>
          )}
          {piUser.username && piUser.username.toLowerCase() === merchant.user?.toLowerCase() && (
            <label style={{ position: 'absolute', bottom: 0, right: 0, background: '#0F6E56', borderRadius: '50%', width: 28, height: 28, display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer', fontSize: 16, color: '#000' }}>
              +
              <input type="file" accept="image/*" style={{ display: 'none' }} onChange={async (e) => {
                const file = e.target.files[0];
                if (!file) return;
                const fd = new FormData();
                fd.append('logo', file);
                const token = localStorage.getItem('token');
                const r = await fetch(BACKEND + '/merchants/upload-logo/', { method: 'POST', headers: { 'Authorization': 'Token ' + token }, body: fd });
                const d = await r.json();
                if (d.success) fetchMerchant();
              }} />
            </label>
          )}
        </div>

        <h1 style={{ fontSize: 28, color: '#0F6E56', margin: '0 0 8px' }}>{merchant.business_name}</h1>

        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, flexWrap: 'wrap', marginBottom: 8 }}>
          {merchant.is_verified && <span style={{ background: '#22c55e', color: '#000', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 'bold' }}>{t('mp_verified_m')}</span>}
          {merchant.plan && <span style={{ background: planColor, color: merchant.plan === 'free' ? '#1a1a2e' : '#fff', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 'bold' }}>{planLabel}</span>}
          {piUser.username && piUser.username.toLowerCase() === merchant.user?.toLowerCase() && (
            <><button onClick={() => navigate('/merchant-tiers')} style={{ background: planColor, color: '#fff', border: 'none', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 'bold', cursor: 'pointer' }}>{t('mp_upgrade')}</button>
            <button onClick={() => { setEditMode(true); setEditForm({ business_name: merchant.business_name, tagline: merchant.tagline, description: merchant.description, phone: merchant.phone, email: merchant.email, website: merchant.website, pi_discount: merchant.pi_discount, facebook: merchant.facebook, instagram: merchant.instagram, linkedin: merchant.linkedin, youtube: merchant.youtube, address: merchant.address, latitude: merchant.latitude, longitude: merchant.longitude }); }} style={{ background: '#0F6E56', color: '#000', border: 'none', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 'bold', cursor: 'pointer' }}>{t('mp_edit')}</button> <button onClick={() => { window.location.href = '/brand-kit'; }} style={{ background: '#0F6E56', color: '#fff', border: 'none', padding: '4px 12px', borderRadius: 20, fontSize: 12, fontWeight: 'bold', cursor: 'pointer' }}>🎨 {t('mp_brandkit')}</button></>
          )}
        </div>

        <p style={{ color: '#aaa', fontSize: 15, margin: '8px 0' }}>{merchant.tagline}</p>
        <div style={{ display: 'flex', justifyContent: 'center', gap: 12, flexWrap: 'wrap' }}>
          {merchant.city && <span style={{ color: '#aaa', fontSize: 13 }}>{merchant.city}, {merchant.country}</span>}
          <span style={{ color: '#0F6E56', fontSize: 13 }}>Avg: {merchant.avg_rating}/5</span>
          {merchant.pi_discount > 0 && <span style={{ background: '#0F6E56', color: '#000', padding: '2px 10px', borderRadius: 20, fontSize: 12, fontWeight: 'bold' }}>{merchant.pi_discount}% Pi Discount</span>}
        </div>
      </div>

      <div style={{ maxWidth: 800, margin: '0 auto', padding: 20 }}>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 20, marginBottom: 24 }}>

          {/* Pay with Pi */}
          <div style={{ background: '#1a1a2e', border: '2px solid #0F6E56', borderRadius: 16, padding: 20 }}>
            <h3 style={{ color: '#0F6E56', margin: '0 0 12px', textAlign: 'center' }}>{t('mp_pay_pi')}</h3>
            <div style={{ background: '#0d1b2a', borderRadius: 10, padding: 12, textAlign: 'center', marginBottom: 12 }}>
              <p style={{ color: '#aaa', fontSize: 12, margin: '0 0 4px' }}>{t('mp_pi_user')}</p>
              <p style={{ color: '#0F6E56', fontSize: 20, fontWeight: 'bold', margin: 0 }}>@{merchant.pi_username}</p>
            </div>

            {!payMode ? (
              <button onClick={() => { setPayMode(true); setPayStatus(''); }}
                style={{ width: '100%', padding: 12, background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, fontSize: 15, fontWeight: 'bold', cursor: 'pointer', marginBottom: 12 }}>
                Pay with Pi
              </button>
            ) : (
              <div style={{ marginBottom: 12 }}>
                <input type="number" value={payAmount} onChange={e => setPayAmount(parseFloat(e.target.value))} min="0.01" step="0.01"
                  placeholder={t('mp_amount_ph')}
                  style={{ width: '100%', padding: 10, background: '#0d1b2a', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 16, boxSizing: 'border-box', marginBottom: 8 }} />
                {merchant.pi_discount > 0 && <p style={{ color: '#22c55e', fontSize: 12, margin: '0 0 8px' }}>{merchant.pi_discount}% discount applied!</p>}
                {payStatus && <p style={{ color: payStatus.includes('Successful') ? '#22c55e' : payStatus.includes('Error') || payStatus.includes('cancel') ? '#ef4444' : '#0F6E56', fontSize: 13, margin: '0 0 8px' }}>{payStatus}</p>}
                <div style={{ display: 'flex', gap: 8 }}>
                  <button onClick={payWithPi} style={{ flex: 1, padding: 10, background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>{t('mp_confirm')}</button>
                  <button onClick={() => setPayMode(false)} style={{ padding: 10, background: '#1a1a2e', color: '#aaa', border: '1px solid #2a2a4a', borderRadius: 8, cursor: 'pointer' }}>{t('mp_cancel')}</button>
                </div>
              </div>
            )}

            {/* QR Code */}
            <div style={{ textAlign: 'center', borderTop: '1px solid #2a2a4a', paddingTop: 12 }}>
              <p style={{ color: '#aaa', fontSize: 12, margin: '0 0 8px' }}>{t('mp_scan')}</p>
              <div style={{ background: '#fff', borderRadius: 8, padding: 8, display: 'inline-block' }}>
                <img src={'https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=' + encodeURIComponent('pi://payment?username=' + merchant.pi_username)} alt="QR" width="120" height="120" />
              </div>
            </div>
          </div>

          {/* Contact */}
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20 }}>
            <h3 style={{ color: '#fff', margin: '0 0 12px' }}>{t('mp_contact')}</h3>
            {merchant.phone && (
              <div style={{ display: 'flex', gap: 8, marginBottom: 8, flexWrap: 'wrap' }}>
                <a href={'https://wa.me/' + merchant.phone.replace(/[^0-9]/g, '')} target="_blank" rel="noopener"
                  style={{ background: '#25D366', color: '#fff', padding: '6px 12px', borderRadius: 8, fontSize: 12, textDecoration: 'none', fontWeight: 'bold' }}>{t('mp_wa_chat')}</a>
                <a href={'https://wa.me/' + merchant.phone.replace(/[^0-9]/g, '')} target="_blank" rel="noopener"
                  style={{ background: '#128C7E', color: '#fff', padding: '6px 12px', borderRadius: 8, fontSize: 12, textDecoration: 'none', fontWeight: 'bold' }}>{t('mp_wa_call')}</a>
                <span style={{ color: '#aaa', fontSize: 13, alignSelf: 'center' }}>{merchant.phone}</span>
              </div>
            )}
            {merchant.email && <p style={{ color: '#aaa', margin: '6px 0', fontSize: 13 }}>{merchant.email}</p>}
            {merchant.website && <a href={merchant.website} target="_blank" rel="noopener" style={{ color: '#0F6E56', display: 'block', margin: '6px 0', fontSize: 13 }}>{merchant.website}</a>}
            {merchant.address && <p style={{ color: '#aaa', margin: '6px 0', fontSize: 13 }}>{merchant.address}</p>}
            <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap', marginTop: 12 }}>
              {merchant.facebook && <a href={merchant.facebook} target="_blank" rel="noopener" style={{ background: '#1877f2', color: '#fff', padding: '6px 12px', borderRadius: 8, fontSize: 12, textDecoration: 'none' }}>Facebook</a>}
              {merchant.instagram && <a href={merchant.instagram} target="_blank" rel="noopener" style={{ background: '#e1306c', color: '#fff', padding: '6px 12px', borderRadius: 8, fontSize: 12, textDecoration: 'none' }}>Instagram</a>}
              {merchant.linkedin && <a href={merchant.linkedin} target="_blank" rel="noopener" style={{ background: '#0077b5', color: '#fff', padding: '6px 12px', borderRadius: 8, fontSize: 12, textDecoration: 'none' }}>LinkedIn</a>}
              {merchant.youtube && <a href={merchant.youtube} target="_blank" rel="noopener" style={{ background: '#ff0000', color: '#fff', padding: '6px 12px', borderRadius: 8, fontSize: 12, textDecoration: 'none' }}>YouTube</a>}
            </div>
          </div>
        </div>

        {/* About */}
        {merchant.description && (
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20, marginBottom: 24 }}>
            <h3 style={{ color: '#fff', margin: '0 0 12px' }}>{t('mp_about')}</h3>
            <p style={{ color: '#aaa', lineHeight: 1.6, margin: 0 }}>{merchant.description}</p>
          </div>
        )}

        {/* Sales */}
        <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20, marginBottom: 24 }}>
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <h3 style={{ color: '#fff', margin: 0 }}>Sales ({merchant.total_transactions || 0})</h3>
            <button onClick={() => { setShowTx(!showTx); if (!showTx) fetchTransactions(); }}
              style={{ background: '#0d1b2a', color: '#0F6E56', border: '1px solid #2a2a4a', borderRadius: 8, padding: '6px 14px', cursor: 'pointer', fontSize: 13 }}>
              {showTx ? 'Hide' : 'Show'}
            </button>
          </div>
          <div style={{ display: 'flex', gap: 12 }}>
            <div style={{ flex: 1, background: '#0d1b2a', borderRadius: 8, padding: 12, textAlign: 'center' }}>
              <div style={{ color: '#0F6E56', fontSize: 22, fontWeight: 'bold' }}>{merchant.total_pi_received || 0} Pi</div>
              <div style={{ color: '#aaa', fontSize: 11 }}>{t('mp_total_pi')}</div>
            </div>
            <div style={{ flex: 1, background: '#0d1b2a', borderRadius: 8, padding: 12, textAlign: 'center' }}>
              <div style={{ color: '#0F6E56', fontSize: 22, fontWeight: 'bold' }}>{merchant.total_transactions || 0}</div>
              <div style={{ color: '#aaa', fontSize: 11 }}>{t('mp_total_sales')}</div>
            </div>
          </div>
          {showTx && (
            <div style={{ marginTop: 12 }}>
              {transactions.length === 0 ? <p style={{ color: '#aaa', textAlign: 'center' }}>{t('mp_no_tx')}</p> :
               transactions.map((tx, i) => (
                <div key={i} style={{ borderBottom: '1px solid #2a2a4a', padding: '8px 0', display: 'flex', justifyContent: 'space-between' }}>
                  <div><span style={{ color: '#fff' }}>@{tx.buyer}</span><span style={{ color: '#555', fontSize: 11, marginLeft: 8 }}>{tx.date}</span></div>
                  <span style={{ color: '#0F6E56', fontWeight: 'bold' }}>{tx.pi_amount} Pi</span>
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Verification - only for owner */}
        {currentUser.username === merchant.user && (
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20, marginBottom: 24 }}>
            <h3 style={{ color: '#fff', margin: '0 0 16px' }}>{t('mp_verification')}</h3>
            {verifMsg && <p style={{ color: verifMsg.includes('verified') ? '#22c55e' : '#ef4444', marginBottom: 12 }}>{verifMsg}</p>}
            
            {/* Email Verification */}
            <div style={{ background: '#0d1b2a', borderRadius: 10, padding: 14, marginBottom: 12 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ color: '#fff', fontWeight: 'bold' }}>{t('mp_email_verif')}</span>
                {verifStatus?.email_verified ? 
                  <span style={{ background: '#22c55e', color: '#000', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 'bold' }}>{t('mp_verified')}</span> :
                  <span style={{ background: '#ef4444', color: '#fff', padding: '2px 8px', borderRadius: 10, fontSize: 12 }}>{t('mp_not_verified')}</span>
                }
              </div>
              {!verifStatus?.email_verified && (
                <>
                  <p style={{ color: '#aaa', fontSize: 13, margin: '0 0 8px' }}>{merchant.email || 'No email on file - add in Edit Profile'}</p>
                  {merchant.email && (
                    <>
                      <button onClick={async () => {
                        const token = localStorage.getItem('token');
                        const r = await fetch(BACKEND + '/merchants/verify/send-email/', { method: 'POST', headers: { 'Authorization': 'Token ' + token, 'Content-Type': 'application/json' } });
                        const d = await r.json();
                        setVerifMsg(d.message || d.error);
                      }} style={{ padding: '8px 16px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold', marginBottom: 8, width: '100%' }}>
                        Send Email Code
                      </button>
                      <div style={{ display: 'flex', gap: 8 }}>
                        <input value={emailCode} onChange={e => setEmailCode(e.target.value)} placeholder={t('mp_code_ph')}
                          style={{ flex: 1, padding: '8px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14 }} />
                        <button onClick={async () => {
                          const token = localStorage.getItem('token');
                          const r = await fetch(BACKEND + '/merchants/verify/email-code/', { method: 'POST', headers: { 'Authorization': 'Token ' + token, 'Content-Type': 'application/json' }, body: JSON.stringify({ code: emailCode }) });
                          const d = await r.json();
                          setVerifMsg(d.message || d.error);
                          if (d.success) fetchVerifStatus();
                        }} style={{ padding: '8px 16px', background: '#22c55e', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold' }}>{t('mp_verify')}</button>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>

            {/* WhatsApp Verification */}
            <div style={{ background: '#0d1b2a', borderRadius: 10, padding: 14 }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
                <span style={{ color: '#fff', fontWeight: 'bold' }}>{t('mp_wa_verif')}</span>
                {verifStatus?.whatsapp_verified ? 
                  <span style={{ background: '#22c55e', color: '#000', padding: '2px 8px', borderRadius: 10, fontSize: 12, fontWeight: 'bold' }}>{t('mp_verified')}</span> :
                  <span style={{ background: '#ef4444', color: '#fff', padding: '2px 8px', borderRadius: 10, fontSize: 12 }}>{t('mp_not_verified')}</span>
                }
              </div>
              {verifMsg && verifMsg.startsWith('CODE:') && (
                <div style={{ background: '#0d2a1a', border: '2px solid #22c55e', borderRadius: 10, padding: 16, marginBottom: 12, textAlign: 'center' }}>
                  <p style={{ color: '#aaa', fontSize: 12, margin: '0 0 4px' }}>{t('mp_wa_code')}</p>
                  <p style={{ color: '#22c55e', fontSize: 32, fontWeight: 'bold', margin: 0, letterSpacing: 8 }}>{verifMsg.replace('CODE: ', '')}</p>
                  <p style={{ color: '#aaa', fontSize: 11, margin: '8px 0 0' }}>{t('mp_code_below')}</p>
                </div>
              )}
              {!verifStatus?.whatsapp_verified && (
                <>
                  <p style={{ color: '#aaa', fontSize: 13, margin: '0 0 8px' }}>{merchant.phone || 'No phone on file - add in Edit Profile'}</p>
                  {merchant.phone && (
                    <>
                      <button onClick={async () => {
                        const token = localStorage.getItem('token');
                        setVerifMsg('Sending...');
                        const r = await fetch(BACKEND + '/merchants/verify/send-whatsapp/', { method: 'POST', headers: { 'Authorization': 'Token ' + token, 'Content-Type': 'application/json' } });
                        const d = await r.json();
                        if (d.success) { 
                          setWaLink(d.wa_link); 
                          setVerifMsg('Code: ' + d.code + ' - Click WhatsApp button below');
                          window.open(d.wa_link, '_blank');
                        }
                        else setVerifMsg(d.error || 'Error');
                      }} style={{ padding: '8px 16px', background: '#25D366', color: '#fff', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold', marginBottom: 8, width: '100%' }}>
                        Send WhatsApp Code
                      </button>
                      {waLink && (
                        <a href={waLink} target="_blank" rel="noopener"
                          style={{ display: 'block', padding: '8px 16px', background: '#128C7E', color: '#fff', borderRadius: 8, textAlign: 'center', textDecoration: 'none', fontWeight: 'bold', marginBottom: 8 }}>
                          Open WhatsApp to get code
                        </a>
                      )}
                      <div style={{ display: 'flex', gap: 8 }}>
                        <input value={waCode} onChange={e => setWaCode(e.target.value)} placeholder={t('mp_code_ph')}
                          style={{ flex: 1, padding: '8px', background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14 }} />
                        <button onClick={async () => {
                          const token = localStorage.getItem('token');
                          const r = await fetch(BACKEND + '/merchants/verify/whatsapp-code/', { method: 'POST', headers: { 'Authorization': 'Token ' + token, 'Content-Type': 'application/json' }, body: JSON.stringify({ code: waCode }) });
                          const d = await r.json();
                          setVerifMsg(d.message || d.error);
                          if (d.success) { fetchVerifStatus(); fetchMerchant(); }
                        }} style={{ padding: '8px 16px', background: '#22c55e', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold' }}>{t('mp_verify')}</button>
                      </div>
                    </>
                  )}
                </>
              )}
            </div>
          </div>
        )}

        {/* Reviews */}
        <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 20 }}>
          <h3 style={{ color: '#fff', margin: '0 0 16px' }}>Reviews ({merchant.reviews?.length || 0})</h3>
          <div style={{ background: '#0d1b2a', borderRadius: 10, padding: 14, marginBottom: 16 }}>
            <p style={{ color: '#aaa', fontSize: 13, margin: '0 0 8px' }}>{t('mp_rate')}</p>
            <div style={{ display: 'flex', gap: 6, marginBottom: 8 }}>
              {[1,2,3,4,5].map(r => (
                <button key={r} onClick={() => setReview({...review, rating: r})}
                  style={{ background: r <= review.rating ? '#0F6E56' : '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 6, padding: '6px 10px', cursor: 'pointer', fontSize: 16, color: r <= review.rating ? '#000' : '#fff' }}>
                  {r}
                </button>
              ))}
            </div>
            <textarea value={review.comment} onChange={e => setReview({...review, comment: e.target.value})}
              placeholder={t('mp_review_ph')}
              style={{ width: '100%', padding: 10, background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 13, resize: 'vertical', minHeight: 70, boxSizing: 'border-box' }} />
            {reviewMsg && <p style={{ color: reviewMsg.includes('submitted') ? '#22c55e' : '#ef4444', margin: '6px 0 0', fontSize: 13 }}>{reviewMsg}</p>}
            <button onClick={submitReview} style={{ marginTop: 8, padding: '8px 18px', background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, cursor: 'pointer', fontWeight: 'bold' }}>{t('mp_submit_rev')}</button>
          </div>
          {merchant.reviews?.length === 0 ? (
            <p style={{ color: '#aaa', textAlign: 'center' }}>{t('mp_no_rev')}</p>
          ) : merchant.reviews?.map((r, i) => (
            <div key={i} style={{ borderBottom: '1px solid #2a2a4a', padding: '10px 0' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 4 }}>
                <span style={{ color: '#0F6E56', fontWeight: 'bold' }}>@{r.reviewer}</span>
                <span style={{ color: '#aaa', fontSize: 12 }}>{r.date}</span>
              </div>
              <div style={{ color: '#0F6E56', marginBottom: 4 }}>{r.rating}/5</div>
              <p style={{ color: '#aaa', margin: 0, fontSize: 13 }}>{r.comment}</p>
            </div>
          ))}
        </div>
      </div>
      {/* Edit Modal */}
      {editMode && (
        <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, background: 'rgba(0,0,0,0.85)', zIndex: 1000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20, overflowY: 'auto' }}>
          <div style={{ background: '#1a1a2e', border: '1px solid #2a2a4a', borderRadius: 16, padding: 24, maxWidth: 500, width: '100%', maxHeight: '90vh', overflowY: 'auto' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 16 }}>
              <h3 style={{ margin: 0, color: '#0F6E56' }}>{t('mp_edit')}</h3>
              <button onClick={() => setEditMode(false)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 24, cursor: 'pointer' }}>x</button>
            </div>
            {[
              { key: 'business_name', label: 'Business Name' },
              { key: 'tagline', label: 'Tagline' },
              { key: 'phone', label: 'Phone' },
              { key: 'email', label: 'Email' },
              { key: 'website', label: 'Website' },
              { key: 'pi_discount', label: 'Pi Discount %' },
              { key: 'address', label: 'Address' },
              { key: 'latitude', label: 'Latitude' },
              { key: 'longitude', label: 'Longitude' },
              { key: 'facebook', label: 'Facebook URL' },
              { key: 'instagram', label: 'Instagram URL' },
              { key: 'linkedin', label: 'LinkedIn URL' },
              { key: 'youtube', label: 'YouTube URL' },
            ].map(f => (
              <div key={f.key} style={{ marginBottom: 10 }}>
                <label style={{ display: 'block', color: '#aaa', fontSize: 12, marginBottom: 3 }}>{f.label}</label>
                <input value={editForm[f.key] || ''} onChange={e => setEditForm({...editForm, [f.key]: e.target.value})}
                  style={{ width: '100%', padding: '8px 12px', background: '#0d1b2a', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14, boxSizing: 'border-box' }} />
              </div>
            ))}
            <div style={{ marginBottom: 12 }}>
              <label style={{ display: 'block', color: '#aaa', fontSize: 12, marginBottom: 3 }}>{t('mp_desc')}</label>
              <textarea value={editForm.description || ''} onChange={e => setEditForm({...editForm, description: e.target.value})}
                style={{ width: '100%', padding: '8px 12px', background: '#0d1b2a', border: '1px solid #2a2a4a', borderRadius: 8, color: '#fff', fontSize: 14, minHeight: 80, resize: 'vertical', boxSizing: 'border-box' }} />
            </div>
            <button onClick={() => {
              if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(pos => {
                  setEditForm(f => ({...f, latitude: pos.coords.latitude.toFixed(6), longitude: pos.coords.longitude.toFixed(6)}));
                });
              }
            }} style={{ width: '100%', padding: 10, background: '#22c55e', color: '#000', border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer', marginBottom: 12 }}>
              Use Current Location (GPS)
            </button>
            {editMsg && <p style={{ color: editMsg.includes('Updated') ? '#22c55e' : '#ef4444', marginBottom: 10 }}>{editMsg}</p>}
            <button onClick={async () => {
              const token = localStorage.getItem('token');
              try {
                const r = await fetch(BACKEND + '/merchants/update/', {
                  method: 'PUT',
                  headers: { 'Content-Type': 'application/json', 'Authorization': 'Token ' + token },
                  body: JSON.stringify(editForm)
                });
                const d = await r.json();
                if (d.success) { setEditMsg('Updated!'); fetchMerchant(); setTimeout(() => setEditMode(false), 1000); }
                else setEditMsg('Error: ' + (d.error || 'Unknown'));
              } catch(e) { setEditMsg('Error: ' + e.message); }
            }} style={{ width: '100%', padding: 12, background: '#0F6E56', color: '#000', border: 'none', borderRadius: 8, fontWeight: 'bold', cursor: 'pointer' }}>
              Save Changes
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
